import React from 'react';
import SupplierInvoicesPayments from '../components/SupplierInvoicesPayments';
import { useLocation, useNavigate } from 'react-router-dom';

const SupplierInvoicesPaymentsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get supplier context from location state
  const state = location.state as {
    supplierIds?: number[];
    supplierState?: string;
  } | null;
  
  const supplierIds = state?.supplierIds || [];
  const supplierState = state?.supplierState;
  
  const handleBack = () => {
    // Navigate back to suppliers page
    navigate('/suppliers');
  };
  
  // Validate that we have the required supplier IDs
  if (supplierIds.length === 0) {
    // If no supplier IDs, redirect to suppliers page
    React.useEffect(() => {
      navigate('/suppliers');
    }, [navigate]);
    
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p>No supplier selected. Redirecting to suppliers page...</p>
        </div>
      </div>
    );
  }
  
  const token = localStorage.getItem('token') || '';
  
  return (
    <SupplierInvoicesPayments 
      token={token}
      supplierIds={supplierIds}
      supplierState={supplierState}
      onBack={handleBack}
    />
  );
};

export default SupplierInvoicesPaymentsPage;
